import { baseApi } from '@shared/utils/api/configs/rtkBaseQueryDemo';

import {
  getPublicServiceCatalog,
  getServiceCatalog,
  PUBLIC_SERVICE_CATALOG_TAG,
  SERVICE_CATALOG_TAG,
} from './endpoints';

const serviceCatalogApi = baseApi
  .injectEndpoints({
    endpoints: (builder) => ({
      getServiceCatalog: getServiceCatalog(builder),
      getPublicServiceCatalog: getPublicServiceCatalog(builder),
    }),
  })
  .enhanceEndpoints({
    addTagTypes: [SERVICE_CATALOG_TAG, PUBLIC_SERVICE_CATALOG_TAG],
  });

export const { useGetServiceCatalogQuery, useGetPublicServiceCatalogQuery } = serviceCatalogApi;
